import { render, staticRenderFns } from "./takePictures.vue?vue&type=template&id=44c9ae1a&scoped=true"
import script from "./takePictures.vue?vue&type=script&lang=js"
export * from "./takePictures.vue?vue&type=script&lang=js"
import style0 from "./takePictures.vue?vue&type=style&index=0&id=44c9ae1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c9ae1a",
  null
  
)

export default component.exports